module.exports.siteLanguages = ["en", "de"].concat(
  (process.env.GATSBY_ENABLE_ADDITIONAL_LANGUAGES || "")
    .split(" ")
    .filter((s) => s),
)
